<template>
	<main>

		<backbar :tit="$t('service.questionsDesc')" to="serviceH5History"></backbar>

		<div class="container" :class="{jp: $region === 'jp'}">

			<div class="remind" v-if="attachments.length==0 && $region != 'jp'">{{$t('service.replyProblems')}}！</div>
			
			<div class="info_box">
				<h5>{{$t('service.account')}}</h5>
				<p v-text="user_mid"></p>
			</div>

			<div class="info_box">
				<h5>{{$t('service.game')}}</h5>
				<p v-text="game_name"></p>
			</div>

			<div class="info_box">
				<h5>{{$t('service.questionsType')}}</h5>
				<p v-text="questionType[question_type]"></p>
			</div>

			<div class="info_box">
				<h5>{{$t('service.roleId')}}</h5>
				<p v-text="character_id"></p>
			</div>

			<div class="info_box">
				<h5>{{$t('service.roleName')}}</h5>
				<p v-text="character_name"></p>
			</div>

			<div class="info_box">
				<h5>{{$t('service.email')}}</h5>
				<p v-text="email"></p>
			</div>

			<!-- <div class="info_box">
				<h5>設定Line Notify</h5>
				<p v-text="lineType[line_notify]"></p>
			</div> -->

			<div class="info_box">
				<h5>{{$t('service.questionsTitle')}}</h5>
				<p v-text="question_title"></p>
			</div>

			<div class="info_box" v-if="question_content">
				<h5>{{$t('service.questionsContent')}}</h5>
				<p v-text="question_content"></p>
			</div>

			<div class="info_box" v-if="attachments.length>0">
				<h5>{{$t('service.record')}}</h5>
				<div class="imgInput">
					<div class="previewImg" v-for="(i,n) in attachments" :key="n" @click="imgView(n)" :style="{backgroundImage:'url('+i+')'}">
						<!-- <img :src="i" alt=""> -->
					</div>
				</div>
			</div>

			<div class="info_box">

				<h5>{{$t('service.serviceReply')}}</h5>

				<div class="replay_item" v-if="!cs_reply_list.length">
					<div class="re_top">
						<img src="../images/time.svg" alt="">
						<span class="time" v-text="create_time"></span>

						<span class="status" :class="'status_'+work_order_status" v-text="statusType[work_order_status]"></span>
					</div>
				</div>

				<div class="replay_item" v-for="(i,n) in cs_reply_list" :key="n">
					<div class="re_top">
						<img src="../images/time.svg" alt="">
						<span class="time" v-text="i.reply_time"></span>
						<span class="status" :class="'status_'+i.reply_status" v-text="statusType[i.reply_status]"></span>
					</div>
					<div class="re_content" v-html="i.reply_content"></div>
				</div>

			</div>

			<div class="info_box level_box" v-if="work_order_status==2||work_order_status==3">
				<h5>{{$t('service.satisfactionEvaluate')}}</h5>
				<div class="star_box">
					<div class="star_item" :class="grade>0?'shine':'gray'" @click="toggleGrade(true,1)"></div>
					<div class="star_item" :class="grade>1?'shine':'gray'" @click="toggleGrade(true,2)"></div>
					<div class="star_item" :class="grade>2?'shine':'gray'" @click="toggleGrade(true,3)"></div>
					<div class="star_item" :class="grade>3?'shine':'gray'" @click="toggleGrade(true,4)"></div>
					<div class="star_item" :class="grade>4?'shine':'gray'" @click="toggleGrade(true,5)"></div>
				</div>
			</div>

			<div class="info_box btn_box">

				<router-link :to="{name:'serviceH5Requestion',query:{id:this.work_order_id}}" v-if="work_order_status==3"  class="block_btn fill_btn">{{$t('service.continueQuestions')}}</router-link>

				<router-link to="/service/h5/question" class="block_btn fill_btn" ga-data="2401001">{{$t('service.addQuestions')}}</router-link>

			</div>

			<pop-window class="postGrade" :title="$t('service.giveHighPraise')" ref="postGrade">

				<div class="star_box">
					<div class="star_item" :class="regrade>0?'shine':'gray'" @click="regrade = 1"></div>
					<div class="star_item" :class="regrade>1?'shine':'gray'" @click="regrade = 2"></div>
					<div class="star_item" :class="regrade>2?'shine':'gray'" @click="regrade = 3"></div>
					<div class="star_item" :class="regrade>3?'shine':'gray'" @click="regrade = 4"></div>
					<div class="star_item" :class="regrade>4?'shine':'gray'" @click="regrade = 5"></div>
				</div>

				<h5 v-text="gradeMap[regrade]||''"></h5>

				<div class="block_btn fill_btn" @click="postGrade">{{$t('service.sure')}}</div>

			</pop-window>

		</div>

		<div class="imgPreview" :class="{out:!showImg}">

			<div class="backbar">
				<div class="back_btn" @click="showImg = false">
					<img src="../images/back.svg" alt="">
				</div>
				<span class="tit">{{$t('service.lookRecord')}} </span>
				<span class="tit swiper-pg" slot="pagination"></span>

			</div>
			
			<swiper :options="swiperOption"  ref="mySwiper">
				
                <!-- 这部分放你要渲染的那些内容 -->  
                <swiper-slide v-for="(i,n) in attachments" :key="n">
					<div class="imgBox">
						<img class="swp_img" :src="i" alt="">
					</div>
                </swiper-slide>  
                
                  
            </swiper>  
		</div>

		<goTop></goTop>
<h5-nav v-if="$region !== 'jp' "></h5-nav>
		<!-- <bottombar></bottombar> -->

	</main>
</template>

<script>	
    import Vue from 'vue';
	// import bottombar from '@/component/bottombar_h5/index.vue';
	import backbar from "@commonBackbar";
	import popWindow from '@/component/popWindow/index.vue';
import h5Nav from "@/component/h5nav/komoe";
	import goTop from './component/goTop';
	import { swiper, swiperSlide } from 'vue-awesome-swiper';

	export default {
		name: "index",
		data() {
            return {
				work_order_id: this.$route.query.id,
				game_base_id: "",
				game_name: "",
				question_type: "",
				create_time: "",
				character_id: "",
				character_name: "",
				email: "",
				line_notify: "",
				question_title: "",
				question_content: "",
				attachments: [],
				work_order_status: "",
				grade: "",
				cs_reply_list: [],
				questionType:{},
				replied_time:"",
				lineType:{
					'0': this.$t('service.isBinding'),
					'-1': this.$t('service.unbounded')
				},
				statusType:{
					1: this.$t('service.noReply'),
					2: this.$t('service.processing'),
					3: this.$t('service.replied'),
					4: this.$t('service.closedCases')
				},
				regrade:0,
				showImg: false,
				swiperOption: {  
                    //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true  
                    notNextTick: true,  
                    pagination: {
						el: '.swiper-pg',
						type: 'fraction'
					},
                    slidesPerView: 'auto',  
                    centeredSlides: true,  
                    paginationClickable: true,  
                    spaceBetween: 30
				},
				user_mid:"",
				gradeMap:{
					1: this.$t('service.disappointed'),
					2: this.$t('service.discontent'),
					3: this.$t('service.general'),
					4: this.$t('service.satisfaction'),
					5: this.$t('service.superPraise')
				}
            };
        },
		components: {
			// bottombar,
			backbar,
			popWindow,
			swiper,  
			swiperSlide,
			goTop,
			h5Nav
		},
		computed: {
			swiper () {
				return this.$refs.mySwiper.swiper;
			}
		},
		methods: {
			cheakAvailable(){
				
				let date = this.replied_time;
				if(date==""){
					return true;
				}
				date = date.substring(0,19);    
				date = date.replace(/-/g,'/'); 
				let timestamp_1 = new Date(date).getTime();
				let timestamp_2 = new Date().getTime();
				if (timestamp_2-timestamp_1>=604800000) {
					return false;
				}else{
					return true;
				}
			},
			toggleGrade(boo,star) {

				if (!this.cheakAvailable()) {
					alert(this.$t('service.outOfGradeDate'));
					return;
				}

				if(this.work_order_status == 1 || this.work_order_status == 4){
					alert(this.$t('service.cannotGrade'));
					return;
				}

				this.$refs.postGrade.poptoggle(boo);
				if (star) {
					this.regrade = star;
				}
			},
			postGrade(){
				this.$apis.service.postOrderGrade(
					this.work_order_id,
					this.regrade,
					this.$utils.token("joy_jct")
				).then((res)=>{
					if (res.data.code == 0) {
						this.grade = this.regrade;
					}else{
						alert(this.$t(`serviceCode.${res.data.code}`)||res.data.message||this.$t('service.evaluateError'));
					}
					this.toggleGrade(false);
				},()=>{
					// console.error(err)
					alert(this.$t('service.networkError'));
					this.toggleGrade(false);
				});
			},
			imgView(i){
				this.showImg = true;
				this.swiper.slideTo(i,0);
			}
		},
		mounted:function(){

			// 获取问题类型列表
			this.$apis.service.commonQuestionTypeList().then((res)=>{
				// console.log(res)
				if (res.data.code == 0) {
					res.data.data.forEach(ele => {
						Vue.set(this.questionType,ele.question_type,ele.question_type_desc);
					});
					
				}
			});

			// 获取工单详情
			this.$apis.service.getOrderDetail(this.work_order_id).then((res)=>{
				// console.log(res)
				if (res.data.code == 0) {
					Object.assign(this,res.data.data);
				}else{
					if (res.data.code == -101) {
						this.$router.push({name: 'login', query: { redirect: encodeURIComponent(location.href) }  });
					}
					// alert(res.data.message || "获取工单详情报错"+res.data.code)
					alert(this.$t(`serviceCode.${res.data.code}`)||res.data.message||this.$t('service.workOrderDescError'));

				}
			},()=>{
				alert(this.$t('service.networkError'));				
			});

			var ct = this.$utils.token("joy_jct");
			this.$apis.service.getConnectInfo(ct).then((res)=>{
				// console.log(res)
				if (res.data.code == 0) {
					this.user_mid = res.data.data.mid;
				}
			});
			
		}
	};

</script>

<style lang="scss">
	@import "../../scss/common_h5.scss";
	@import '~swiper/dist/css/swiper.css';
</style>
<style lang="scss" scoped>	
	.jp{
		padding-top: 0.4rem;
	}
	.info_box{
		margin:.2rem 0; 
		h5{
			font-size: .12rem;
			color: #BDBDBD;
			line-height: .16rem;
			margin: 0 0 .1rem;
			font-weight: normal;
		}
		p{
			margin: 0;
			font-size: .14rem;
			color: $cl_dark;
			line-height: .19rem;
		}
		.imgList{
			
			.imgBox{
				display: inline-block;
				width: 1rem;
				height: 1rem;
				border: 1px solid #CCCCCC;
				border-radius: .2rem;
				overflow: hidden;
				margin-right: .18rem;
				box-sizing: border-box;
				img{
					display: block;
					width: 100%;
				}
				&:last-child{
					margin-right: 0;
				}
			}
		}
		.replay_item{
			background: #F2F2F2;
			border-radius: .12rem;
			overflow: hidden;
			margin-bottom: .1rem;
			.re_top{
				box-sizing: border-box;
				height: .38rem;
				padding: .12rem;
				img{
					float: left;
					width: .1rem;
					height: .1rem;
					margin-right: .04rem;
				}
				.time{
					float: left;
					font-size: .1rem;
					color: #999999;
				}
				.status{
					font-size: .1rem;
					width: auto;
					height: .14rem;
					line-height: .14rem;
					border-radius: .07rem;
					text-align: center;
					float: right;
					color: #ffffff;
					padding: 0 0.05rem;
					&.status_1{
						background: #999999;
					}
					&.status_2{
						background: #FFA0A0;
					}
					&.status_3{
						background: #8FD7C1;
					}
					&.status_4{
						background: #999999;
					}
				}
			}
			.re_content{
				border-top: 1px solid #dddddd;
				padding: .12rem 0;
				margin: 0 .12rem;
				line-height: .19rem;
				font-size: .14rem;
				color: $cl_dark;
				img{
					max-width: 100%;
				}
			}
		}
		.imgInput{
			.previewImg{
				position: relative;
				display: inline-block;
				height: 1rem;
				width: 1rem;
				margin-right: .18rem;
				overflow: hidden;
				border-radius: .2rem;
				background: #999999;
				background-size: cover;
				background-repeat: no-repeat;
				background-position: center center;
				&:last-child{
					margin-right: 0;
				}
				img{
					display: block;
					width: 100%;
				}
			}
		}
	}

	.level_box{
		text-align: center;
		border-top: 1px solid #eeeeee;
		font-size: 0;
		padding: .3rem 0 .2rem;
		h5{
			font-size: .12rem;
			color: #999999;
		}
	}
	.star_box{
		.star_item{
			display: inline-block;
			height: .4rem;
			width: .4rem;
			background: url(../images/star_gray.svg) center center no-repeat;
			background-size: contain;
			margin-right: .2rem;
			&:last-child{
				margin-right: 0;
			}
			&.shine{
				background-image: url(../images/star_shine.svg)
			}
		}
	}
	.btn_box{
		.block_btn{
			margin: .2rem 0;
		}
	}
	.postGrade{
		font-size: 0;
		text-align: center;
		h5{
			font-size: .12rem;
			color: #CCCCCC;
			font-weight: normal;
		}
	}

	.imgPreview{
		position: fixed;
		z-index: 10;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: #000000;
		transition: all .2s;
		&.out{
			top: 100vh;
			opacity: 0;
		}
		.imgBox{
			position: relative;
			width: 100vw;
			height: calc(100vh - .48rem);
			.swp_img{
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%,-50%);
				max-width: 100vw;
				max-height: 100vh;
				width: auto;
				height: auto;
			}

		}
		
	}

	.backbar {
		position: absolute;
		z-index: 10;
		top: 0;
		left: 0;
		width: 100%;
        padding: .14rem .12rem;
        line-height: .2rem;
        height: .48rem;
        background: $cl_green;
        font-size: 0;
        box-sizing: border-box;
        .tit {
            color: #fff;
            font-size: .12rem;
            vertical-align: middle;
        }
        .back_btn {
            display: inline-block;
            vertical-align: middle;
            margin-right: .12rem;
            img {
                width: .2rem;
                display: block;
            }
		}
		.del{
			float: right;
			width: .2rem;
			height: .2rem;
			img{
				display: block;
			}
		}
    }

</style>
